import { COMPLETELY_LOADED_DEFAULT, GOALS_LOADED_MARKER, GOALS_SHOULD_EXCLUDE, PLANNING_LOADED_MARKER } from '@/lib/constants';
import { defaultExclusionCheck } from '@/composables/exclusion-checks';
import { provide } from 'vue';

export const planningGoalExclusionCheck = (entity, context) => entity.completelyLoaded.includes(PLANNING_LOADED_MARKER);

export default function usePlanningExclusionCheck() {
  const shouldExclude = (entity, context) => [defaultExclusionCheck, planningGoalExclusionCheck].every((fn) => fn(entity, context));

  const intercept = (node) => {
    switch (true) {
      case (node instanceof Array): {
        return node.map((e) => intercept(e));
      }
      case (node instanceof Object): {
        if (Array.isArray(node.completelyLoaded) && node.completelyLoaded.includes(COMPLETELY_LOADED_DEFAULT)) {
          node.completelyLoaded.push(PLANNING_LOADED_MARKER);
        }
        Object.keys(node).forEach((k) => {
          intercept(node[k]);
        });
        return node;
      }
      default:
        return node;
    }
  };

  const loadedMarker = { intercept };

  const provideExclusionCheck = () => {
    provide(GOALS_SHOULD_EXCLUDE, shouldExclude);
    provide(GOALS_LOADED_MARKER, loadedMarker);
  };

  return {
    shouldExclude,
    loadedMarker,
    provideExclusionCheck,
  };
}
